import { post } from "./";

export function confirm() {
  return post("Affinity/Platform/TermsAndConditions/Confirm", {});
}
